import { defineMessages } from "react-intl";
export default defineMessages({
  airQuality: {
    "id": "airQuality.airQuality",
    "defaultMessage": "Air quality"
  },
  indoorAirQuality: {
    "id": "airQuality.indoorAirQuality",
    "defaultMessage": "Indoor air quality"
  },
  airQualityIndex: {
    "id": "airQuality.airQualityIndex",
    "defaultMessage": "Air quality index"
  },
  good: {
    "id": "airQuality.good",
    "defaultMessage": "Good"
  },
  goodDescription: {
    "id": "airQuality.goodDescription",
    "defaultMessage": "Air quality is considered satisfactory, and air pollution poses little or no risk"
  },
  moderate: {
    "id": "airQuality.moderate",
    "defaultMessage": "Moderate"
  },
  moderateDescription: {
    "id": "airQuality.moderateDescription",
    "defaultMessage": "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution."
  },
  sensitiveUnhealthy: {
    "id": "airQuality.sensitiveUnhealthy",
    "defaultMessage": "Unhealthy for sensitive people"
  },
  sensitiveUnhealthyDescription: {
    "id": "airQuality.sensitiveUnhealthyDescription",
    "defaultMessage": "Members of sensitive groups may experience health effects. The general public is not likely to be affected."
  },
  unhealthy: {
    "id": "airQuality.unhealthy",
    "defaultMessage": "Unhealthy"
  },
  unhealthyDescription: {
    "id": "airQuality.unhealthyDescription",
    "defaultMessage": "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects"
  },
  veryUnhealthy: {
    "id": "airQuality.veryUnhealthy",
    "defaultMessage": "Very unhealthy"
  },
  veryUnhealthyDezscription: {
    "id": "airQuality.veryUnhealthyDezscription",
    "defaultMessage": "Health warnings of emergency conditions. The entire population is more likely to be affected."
  },
  hazardous: {
    "id": "airQuality.hazardous",
    "defaultMessage": "Hazardous"
  },
  hazardousDescription: {
    "id": "airQuality.hazardousDescription",
    "defaultMessage": "Health alert: anyone may experience more serious health effects"
  },
  pm10: {
    "id": "airQuality.pm10",
    "defaultMessage": "Particles with a diameter of 10 μm or less"
  },
  pm25: {
    "id": "airQuality.pm25",
    "defaultMessage": "Particles with a diameter of 2.5 μm or less"
  },
  o3: {
    "id": "airQuality.o3",
    "defaultMessage": "Ozone"
  },
  co: {
    "id": "airQuality.co",
    "defaultMessage": "Carbon monoxide"
  },
  no2: {
    "id": "airQuality.no2",
    "defaultMessage": "Nitrogen dioxide"
  },
  so2: {
    "id": "airQuality.so2",
    "defaultMessage": "Sulfur dioxide"
  }
});